import { ChevronDownIcon } from "@/icons";
import React, { Dispatch, SetStateAction, useState } from "react";

const baseRowStyle = "grid items-center gap-12 py-4 px-3";
const rowStyle = `${baseRowStyle} border-b border-slate-800`;
const dropdownContentStyle = `border-b border-slate-800`;

type TableProps = {
  children: React.ReactNode;
  className?: string;
};

type TableRowProps = TableProps & {
  dropdown?: boolean;
  dropdownContent?: any;
};

const Table = ({ children, className }: TableProps) => {
  return (
    <div className="scrollbar-x">
      <div className={className}>{children}</div>
    </div>
  );
};

const TableHeaderRow = ({ children, className }: TableProps) => {
  return <div className={`${rowStyle} ${className}`}>{children}</div>;
};

const TableBodyRow = (props: TableRowProps) => {
  const { children, className, dropdown, dropdownContent } = props;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  function handleOnClick() {
    setIsDropdownOpen(!isDropdownOpen);
  }

  return (
    <div className={`group even:bg-tableRow even:bg-gradient-to-r`}>
      <div
        className={`${
          isDropdownOpen ? baseRowStyle : rowStyle
        } group-hover:bg-tableRow__hover ${className}`}
      >
        {children}

        {dropdown && (
          <div className="flex items-center justify-center text-right">
            <button
              onClick={() => (dropdown ? handleOnClick() : null)}
              className={`ease mx-4 text-xl transition duration-150 ${
                isDropdownOpen && " rotate-180"
              }`}
            >
              <ChevronDownIcon />
            </button>
          </div>
        )}
      </div>

      {isDropdownOpen && (
        <div
          className={
            isDropdownOpen
              ? dropdownContentStyle
              : baseRowStyle + dropdownContentStyle
          }
        >
          {dropdownContent}
        </div>
      )}
    </div>
  );
};

const TableHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={`flex items-center text-sm font-semibold text-slate-300`}>
      {children}
    </div>
  );
};

const TableDropdown = (props: { children: React.ReactNode }) => {
  return (
    <div className="px-4 pb-4 group-hover:bg-tableRow__hover">
      <p>{props.children}</p>
    </div>
  );
};

Table.TableHeaderRow = TableHeaderRow;
Table.TableBodyRow = TableBodyRow;
Table.TableHeader = TableHeader;
Table.TableDropdown = TableDropdown;

export default Table;
